import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Button, Card, Headline } from '@sumup-oss/circuit-ui';

import { StyledComponentsParams } from 'types/components';
import { Children } from 'types/common';

const CALLOUT_TYPES_STYLES: Record<string, string> = {
  Tip: 'var(--cui-border-success)',
  Alert: 'var(--cui-border-warning)',
  Note: 'var(--cui-border-accent)',
};

type StyledCalloutType = StyledComponentsParams & {
  type: string;
};

export const StyledCallout = styled(Card)(
  ({ theme, type }: StyledCalloutType) => css`
    position: relative;
    margin-top: ${theme.spacings.tera};
    margin-bottom: ${theme.spacings.mega};

    &:before {
      content: '';
      height: ${theme.spacings.giga};
      position: absolute;
      left: -1px;
      top: 50%;
      transform: translateY(-50%);
      border-color: ${CALLOUT_TYPES_STYLES[type]};
      border-style: solid;
      border-radius: 0 ${theme.borderRadius.mega} ${theme.borderRadius.mega} 0;
      border-width: 0 calc(3 * ${theme.borderWidth.kilo})
        calc(3 * ${theme.borderWidth.kilo}) 0;
    }
  `,
);

export const StyledCardList = styled('div')(
  ({ theme }: StyledComponentsParams & { children?: Children }) => css`
    margin-top: ${theme.spacings.tera};
    margin-bottom: ${theme.spacings.mega};
    border: 2px solid var(--cui-bg-normal-pressed);
    border-radius: ${theme.borderRadius.mega};
    div:first-child {
      border-top-left-radius: ${theme.borderRadius.mega};
      border-top-right-radius: ${theme.borderRadius.mega};
    }
    div:last-child {
      border-bottom-left-radius: ${theme.borderRadius.mega};
      border-bottom-right-radius: ${theme.borderRadius.mega};
      border-bottom: none;
    }
  `,
);

export const DTSBannerContainer = styled(Card)(
  ({ theme }: StyledComponentsParams) => css`
    flex-direction: row;
    padding: ${theme.spacings.tera};
    background-color: var(--cui-bg-subtle);
    border: none;
    margin-top: ${theme.spacings.zetta};

    ${theme.mq.untilMega} {
      flex-direction: column-reverse;
      align-items: center;
      padding: ${theme.spacings.mega};
    }
  `,
);

export const BannerLeft = styled('div')(
  ({ theme }: StyledComponentsParams) => css`
    ${theme.mq.untilMega} {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  `,
);

export const BannerHeadline = styled(Headline)(
  ({ theme }: StyledComponentsParams) => css`
    margin-bottom: ${theme.spacings.byte};
  `,
);

export const BannerButton = styled(Button)(
  ({ theme }: StyledComponentsParams) => css`
    margin-top: ${theme.spacings.byte};
    padding: ${theme.spacings.bit} ${theme.spacings.mega};
  `,
);

export const BannerIcon = styled('div')(
  ({ theme }: StyledComponentsParams) => css`
    ${theme.mq.untilMega} {
      margin-bottom: ${theme.spacings.mega};
    }
  `,
);
